<template>
    <div class="p-3">
        <h3>Data MR Tidak Aktif</h3>
        <hr>

        <div class="row mt-3">
            <h4 class="mb-3">Pencarian Data</h4>
            <div class="col-sm-3">
                <div class="mb-3 row">
                    <label for="tanggal_dari" class="col-sm-4 col-form-label text-end">Dari</label>
                    <div class="col-sm-8">
                        <input type="date" name="tanggal_dari" id="tanggal_dari" class="form-control" v-model="filter.tanggal_dari">
                    </div>
                </div>
            </div>
            <div class="col-sm-3">
                <div class="mb-3 row">
                    <label for="tanggal_sampai" class="col-sm-4 col-form-label text-end">Sampai</label>
                    <div class="col-sm-8">
                        <input type="date" name="tanggal_sampai" id="tanggal_sampai" class="form-control" v-model="filter.tanggal_sampai">
                    </div>
                </div>
            </div>
            <div class="col-sm-2">
                <div class="mb-3 row">
                    <div class="col-sm-8 text-end">
                        <button class="btn btn-danger" @click="resetFilters"><i class="fa fa-refresh"></i> Reset</button>
                        <button class="btn btn-primary" @click="getPasienTidakAktif"><i class="fa fa-search"></i> Cari</button>
                    </div>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="mb-3 row">
                    <label for="search" class="col-sm-2 col-form-label text-end">Cari Data</label>
                    <div class="col-sm-10">
                        <input type="text" name="search" id="search" class="form-control" v-model="filter.search" placeholder="Nama/NIK/No Kartu/No RM" @change="getPasienTidakAktif">
                    </div>
                </div>
            </div>
        </div>

        <div class="card mb-3">
            <div class="card-header text-white bg-primary">Data Pasien</div>
            <div class="card-body">
                <div id="table-pasien"></div>
            </div>
        </div>
    </div>
</template>

<script>
import { TabulatorFull as Tabulator } from 'tabulator-tables'

export default {
    data() {
        return {
            filter: {
                tanggal_dari: '',
                tanggal_sampai: '',
                search: '',
            },
            table: null,
        }
    },
    created() {
        this.getPasienTidakAktif()
    },
    methods: {
        resetFilters() {
            this.filter.tanggal_dari = ''
            this.filter.tanggal_sampai = ''
            this.getPasienTidakAktif()
        },
        getPasienTidakAktif() {
            const uri = `/api/retensi-dan-pemusnahan/get-pasien-tidak_aktif?start_date=${this.filter.tanggal_dari}&end_date=${this.filter.tanggal_sampai}&search=${this.filter.search}`

            this.axios.get(uri).then(response => {
                console.log('master_pasien', response.data.master_pasien)
                if (response.data.status == 'success') {
                    this.table = new Tabulator("#table-pasien", {
                        data: response.data.master_pasien.data,
                        layout: 'fitColumns',
                        pagination: 'true',
                        paginationMode: 'remote',
                        paginationSize: 10,
                        paginationSizeSelector:[10, 25, 50, 100, true],
                        dataLoader: this.ajaxLoader,
                        ajaxURL: uri,
                        ajaxResponse: this.AjaxResponse,
                        sortMode: 'remote',
                        filterMode: 'remote',
                        columns: [
                            {title: "No. RM", field: "Medrec", sorter: "string"},
                            {title: "Nama", field: "Firstname", sorter: "string"},
                            {title: "NIK", field: "NoIden", sorter: "string"},
                            {title: "No. Kartu BPJS", field: "AskesNo", sorter: "string"},
                            {title: "Jenis Kelamin", field: "Sex", sorter: "string"},
                            {title: "Tanggal Lahir", field: "Bod", sorter: "string"},
                            {title: "Tanggal Daftar", field: "tgl_daftar", sorter: "string"},
                            {title: "Tanggal Pemusnahan", field: "Deleted", sorter: "string"},
                        ]
                    })
                }
            })
        },
        ajaxLoader() {
            // set loading screen
        },
        AjaxResponse(url, params, response) {
            return response[0].master_pasiens
        },
    }
}
</script>